import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { Provider } from "react-redux"
import ExperimentInitializer from "../components/ExperimentInitializer"
import PageAnalyticsInitializer from "../components/PageAnalyticsInitializer"
import { SearchUrlParametersContextProvider } from "../context/SearchUrlParametersContext"
import { createWrapperWithStore } from "."

const queryClient = new QueryClient()

export default createWrapperWithStore((store) => ({ element }) => (
  <QueryClientProvider client={queryClient}>
    <SearchUrlParametersContextProvider>
      <Provider store={store}>
        <ExperimentInitializer />
        <PageAnalyticsInitializer />
        {element}
      </Provider>
    </SearchUrlParametersContextProvider>
  </QueryClientProvider>
))
